module.exports = __webpack_public_path__ + "img/80400.e67e3205.jpg";